module.exports = __webpack_public_path__ + "4b0061cce14eafd45e4081f1b010b5c5.pdf";